import Home from './components/home/Home.vue';
import Login from './components/login/Login.vue'
import MakeYourBookings from './components/make-your-bookings/MakeYourBookings.vue'
import SeeYourBookings from './components/see-your-bookings/SeeYourBookings.vue'
import ReservationWidget from './components/shared/ReservationWidget.vue';
import ChangePassword from './components/change-password/ChangePassword.vue';

export const homeChildrenPath = [
  { path: '/search', name: "search", component: MakeYourBookings, beforeEnter: checkAuthentication },
	{ path: '/see-your-bookings', component: SeeYourBookings, beforeEnter: checkAuthentication },
  { path: "/login", name: "login", component: Login, beforeEnter: checkNotAuthentication },
];

export const routes = [
  { path: "/user/change-password", name: "changePassword", component: ChangePassword },
  { path: '/widget/:type/:username/:password', props: true, component: ReservationWidget },
  { path: "", redirect: '/search', component: Home, children: homeChildrenPath }
]

function checkAuthentication(to, from, next) {
	if (localStorage.getItem('token:online-reservation')){
    next();
  } else {
    next('/login');
  }
}

function checkNotAuthentication(to, from, next) {
	if (localStorage.getItem('token:online-reservation') == null){
		next()
  } else {
    next('/search');
	}
}



// WEBPACK FOOTER //
// ./src/routes.js